/**
 * Customer-facing label used in co-application disclosure copy.
 * Turns is branded as "Turns Financing"; Finturf uses the bare display name.
 */
export const getSecondLookDisclosureLabel = (providerName: string | null | undefined): string => {
    if (!providerName) {
        return '';
    }

    const normalized = providerName.toLowerCase();
    if (normalized === 'turns') {
        return 'Turns Financing';
    }
    if (normalized === 'finturf') {
        return 'Finturf';
    }

    return `${providerName} Financing`;
};

/**
 * Resolves `{secondLookProvider}` placeholders in first-look co-application disclosure templates.
 */
export const resolveSecondLookDisclosureText = (
    template: string | undefined,
    secondLookProvider: string | null | undefined,
): string | undefined => {
    if (!template) {
        return template;
    }

    return template.replaceAll(
        '{secondLookProvider}',
        getSecondLookDisclosureLabel(secondLookProvider),
    );
};
